import SettingsRoute from 'webapp/routes/genie/settings';

export default class MobileGenieSettingsRoute extends SettingsRoute {
	protected override get chatRoute(): string {
		return 'mobile.genie';
	}
}
